export default __webpack_public_path__ + "static/logo-192-dc5bbb920234fd804ddbe6a17ff9b067.png";